import { useParams } from 'react-router-dom';
import DashboardDataEntry from '../dashboard-v1/DashboardDataEntry';

const DashboardDataEntryTab = ({ location }) => {
  const params = useParams();
  const locationId =
    location?.id || params.id || params['*']?.split('/').filter(Boolean)[0];

  return <DashboardDataEntry locationId={locationId} />;
};

export default DashboardDataEntryTab;
